import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=1c9e63f3&scoped=true&"
import script from "./WelcomePage.vue?vue&type=script&lang=js&"
export * from "./WelcomePage.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePage.vue?vue&type=style&index=0&id=1c9e63f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e63f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9e63f3')) {
      api.createRecord('1c9e63f3', component.options)
    } else {
      api.reload('1c9e63f3', component.options)
    }
    module.hot.accept("./WelcomePage.vue?vue&type=template&id=1c9e63f3&scoped=true&", function () {
      api.rerender('1c9e63f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/WelcomePage.vue"
export default component.exports